export default __webpack_public_path__ + "static/media/foodclassification.a71b49f3.png";